// extracted by mini-css-extract-plugin
module.exports = {"fullWidthContainer":"jgp-3bqex","container":"jgp-3iVNt","tab":"jgp-17MHU","label":"jgp-3O1OW"};